import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "ScheduledItemsOverview" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Type"),
  /*#__PURE__*/_createElementVNode("th", null, "Date"),
  /*#__PURE__*/_createElementVNode("th", null, "Status"),
  /*#__PURE__*/_createElementVNode("th", null, "Valid"),
  /*#__PURE__*/_createElementVNode("th", { class: "WideCell" }, " Reasons for being invalid ")
], -1 /* HOISTED */)
const _hoisted_4 = { class: "WideCell" }
const _hoisted_5 = {
  key: 0,
  class: "InvalidReasonsList"
}
const _hoisted_6 = {
  key: 1,
  class: "SchedulingOverviewDescription"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.hasRetrievalCompleted)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.campaignIsRelevantForScheduler)
            ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
                _hoisted_3,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validatedScheduledItems, (item) => {
                  return (_openBlock(), _createElementBlock("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(item.type) + " date", 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.date), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.status), 1 /* TEXT */),
                    _createElementVNode("td", null, [
                      _createElementVNode("i", {
                        class: _normalizeClass(item.valid)
                      }, null, 2 /* CLASS */)
                    ]),
                    _createElementVNode("td", _hoisted_4, [
                      (item.reasons.length)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.reasons, (reason) => {
                              return (_openBlock(), _createElementBlock("li", null, _toDisplayString(reason), 1 /* TEXT */))
                            }), 256 /* UNKEYED_FRAGMENT */))
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]))
                }), 256 /* UNKEYED_FRAGMENT */))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, " There are no scheduled tasks for this campaign. This means that, on the start and end date, the campaign will not start or end automatically. "))
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ]))
}